import { MenuItem, TextField, TextFieldProps } from '@material-ui/core';
import React from 'react';

import { DisabledOn } from '../../../types';
import { useTranslation } from 'react-i18next';

type Props = TextFieldProps & {
  value?: DisabledOn;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
};

const DisabledOnSelect: React.FC<Props> = ({
  value = DisabledOn.NEVER,
  onChange,
  label,
  ...props
}) => {
  const { t } = useTranslation('customerFormBeta', {
    keyPrefix: 'config.disabled',
  });
  return (
    <TextField
      select
      onChange={onChange}
      value={value}
      fullWidth
      label={label}
      {...props}
    >
      <MenuItem value={DisabledOn.ALWAYS}>{t('always')}</MenuItem>
      <MenuItem value={DisabledOn.NEVER}>{t('never')}</MenuItem>
      <MenuItem value={DisabledOn.ON_EDIT}>{t('onEdit')}</MenuItem>
    </TextField>
  );
};

export default DisabledOnSelect;
